import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";

export const WarningModal = ({ modal, setModal }) => {
  const [inputValue, setInputValue] = useState("");
  const toggle = () => setModal({ ...modal, show: !modal.show });

  return (
    <Modal isOpen={modal.show} toggle={toggle} centered>
      <ModalHeader>
        <div className="row m-0">
          <div className="col m-auto">{modal.title}</div>
        </div>
      </ModalHeader>
      <ModalBody>
        <Form style={{ padding: 0 }}>
          <FormGroup>
            <div>
              <p className="text-muted mb-0">{modal.message}</p>

              {modal.input && (
                <>
                  <Label for="mission-name">Nome</Label>

                  <Input
                    id="mission-name"
                    placeholder="Nome da Missão"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                </>
              )}
            </div>

            <div>
              <Button
                outline
                className="col-12 mt-3"
                disabled={modal.input && inputValue === ""}
                onClick={() => {
                  modal.onConfirm?.(inputValue);
                  toggle();
                }}
              >
                {modal.buttonText}
              </Button>
              <Button
                outline
                className="col-12 mt-3"
                onClick={() => {
                  modal.onCancel?.();
                  toggle();
                }}
              >
                Cancelar
              </Button>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
};
